const state = {
    displayRegisterBusiness : false,
    displayContactForm : false,
}


export default {
    namespaced:true,
    state,
}